import { createContext, ReactNode, useContext, useRef } from 'react';

import { useUrlQuery } from '@hooks';

const ENTRY_POINT = 'entryPoint';

export type EditorEntryPoint =
  | 'documents'
  | 'editingDocuments'
  | 'templates'
  | 'create-approvals'
  /**
   * 아래 string & {} 타입은 `edit-approval:${approvalId}`, `drafts:${draftId}`  형식으로 넘겨주기 위함입니다.
   * EditorEntryPoint의 타입을 string으로 명시적으로 개방하지 않으면서도 string으로 열어주게 됩니다.
   * @see https://www.typescriptlang.org/docs/handbook/2/template-literal-types.html
   */
  // eslint-disable-next-line @typescript-eslint/ban-types
  | (string & {});

type EditorEntryPointContextValue = EditorEntryPoint;

const EditorEntryPointContext = createContext<EditorEntryPointContextValue>('drafts');

export function EditorEntryPointProvider({ children }: { children: ReactNode }) {
  const query = useUrlQuery();
  const editorentryPoint = useRef<EditorEntryPoint>(query.get(ENTRY_POINT) as EditorEntryPoint);

  return (
    <EditorEntryPointContext.Provider value={editorentryPoint.current ?? 'drafts'}>
      {children}
    </EditorEntryPointContext.Provider>
  );
}

export const useEditorEntryPoint = (): EditorEntryPointContextValue => {
  return useContext(EditorEntryPointContext);
};

/**
 * 문서 에디터 진입 시, EditorEntryPoint에 명세한 진입 맥락으로 가지고 이동하기 위한 path를 반환합니다
 * @return `/editor/others-require/etc?editorentryPoint=${editorentryPoint}`;
 */
export const getEditorEntryPath = (entryPoint: EditorEntryPoint) => {
  return `/editor/others-require/etc?${ENTRY_POINT}=${entryPoint}`;
};
